import Vue from 'vue';
import Vuex from 'vuex';
import Route from '@/route';
import snackbar from '@/store/modules/snackbar';
/* eslint-disable import/no-cycle */
import simpleSearch from '@/store/modules/simpleSearch';
import salesforceSearch from '@/store/modules/salesforceSearch';
import adHocPurchase from '@/store/modules/adHocPurchase';
import customerEditEmail from '@/store/modules/customerEditEmail';
import customerEdit from '@/store/modules/customerEdit';
import customerLinkAccounts from '@/store/modules/customerLinkAccounts';
import customerLinkedAccounts from '@/store/modules/customerLinkedAccounts';
import customerUnlinkAccount from '@/store/modules/customerUnlinkAccount';
import customerCreate from '@/store/modules/customerCreate';
import customerDetail from '@/store/modules/customerDetail';
import customerMsp from '@/store/modules/customerMsp';
import customerResetPassword from '@/store/modules/customerResetPassword';
import customerSetPassword from '@/store/modules/customerSetPassword';
import deleteCustomer from '@/store/modules/customerDelete';
import customerSessions from '@/store/modules/customerSessions';
import applications from '@/store/modules/application';
import applicationPermissions from '@/store/modules/applicationPermission';
import Api from '@/api';
/* eslint-enable import/no-cycle */
Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        snackbar,
        simpleSearch,
        salesforceSearch,
        customerCreate,
        customerDetail,
        customerMsp,
        customerEdit,
        customerEditEmail,
        customerLinkedAccounts,
        customerLinkAccounts,
        customerUnlinkAccount,
        customerResetPassword,
        customerSetPassword,
        adHocPurchase,
        deleteCustomer,
        customerSessions,
        applications,
        applicationPermissions,
    },
    state: {
        isLoggedIn: false,
        lastPathName: Route.SEARCH.name,
        userRoles: [],
        user: {
            id: -1,
            username: '',
            email: '',
        },
        defaultUser: {
            id: -1,
            username: '',
            email: '',
        },
        userRolesLoading: false,
        userLoading: false,
        maskView: false,
    },
    /* eslint-disable no-param-reassign */
    mutations: {
        maskView(state) {
            state.maskView = true;
        },
        demaskView(state) {
            state.maskView = false;
        },
        login(state) {
            state.isLoggedIn = true;
        },
        logout(state) {
            state.isLoggedIn = false;
            state.userRoles = [];
        },
        redirectTo(state, pathName) {
            state.lastPathName = pathName;
        },
        /* eslint-disable-next-line */
        loadUserRolesRequest(state) {
            // do nothing
            state.userRolesLoading = true;
        },
        loadUserRolesSuccess(state, userRoles) {
            state.userRoles = userRoles;
            state.userRolesLoading = false;
        },
        loadUserRolesFailure(state) {
            state.userRoles = [];
            state.userRolesLoading = false;
        },
        loadUser(state) {
            Vue.set(state, 'user', state.defaultUser);
            state.userLoading = true;
        },
        loadUserSuccess(state, user) {
            state.userLoading = false;
            Vue.set(state, 'user', user);
        },
        loadUserFailure(state) {
            state.userLoading = true;
            Vue.set(state, 'user', state.defaultUser);
        },
    },
    actions: {
        login({ commit, state, dispatch }) {
            if (!state.isLoggedIn) {
                commit('login');
                dispatch('loadUserInfo');
            }
        },
        loadUserRoles({ commit }) {
            commit('loadUserRolesRequest');
            return new Promise((resolve, reject) => {
                Api.user.getRoles()
                    .then(({ data }) => {
                        commit('loadUserRolesSuccess', data.roles);
                        return resolve();
                    /* eslint-disable-next-line */
                    }).catch((response) => {
                        commit('loadUserRolesFailure');
                        return reject();
                    });
            });
        },
        loadUserInfo({ commit }) {
            commit('loadUser');
            return new Promise((resolve, reject) => {
                Api.user.getUser()
                    .then(({ data }) => {
                        commit('loadUserSuccess', data);
                        return resolve();
                    /* eslint-disable-next-line */
                    }).catch((response) => {
                        commit('loadUserFailure');
                        return reject();
                    });
            });
        },
    },
    getters: {
        isDeveloper: state => state.userRoles.indexOf('Developer') > -1,
        isAdmin: state => state.userRoles.indexOf('Admin') > -1,
        isLeserservice: state => state.userRoles.indexOf('Leserservice') > -1,
        isLeserserviceLeitung: state => state.userRoles.indexOf('Leserservice-Leitung') > -1,
        isLeserserviceOrHigher: state => state.userRoles.some(x => ['Leserservice', 'Leserservice-Leitung', 'Admin', 'Developer'].includes(x)),
        isLeserserviceLeitungOrHigher: state => state.userRoles.some(x => ['Leserservice-Leitung', 'Admin', 'Developer'].includes(x)),
        isAdminOrHigher: state => state.userRoles.some(x => ['Admin', 'Developer'].includes(x)),
    },
    /* eslint-enable no-param-reassign */
});
